import { render } from "./Tal_commonMemoPop.vue?vue&type=template&id=35f1884e&scoped=true"
import script from "./Tal_commonMemoPop.vue?vue&type=script&lang=js"
export * from "./Tal_commonMemoPop.vue?vue&type=script&lang=js"

import "./Tal_commonMemoPop.vue?vue&type=style&index=0&id=35f1884e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f1884e"]])

export default __exports__